import {
  ContentWidgetElement,
  SectionWidgetElement,
  WrapperElement,
} from "@easy-email-pro-core/typings";
import React, { useContext } from "react";

export interface WidgetElementContextProps {
  element: ContentWidgetElement | SectionWidgetElement | WrapperElement | null;
}

const WidgetElementContext = React.createContext<WidgetElementContextProps>(
  {} as any
);

export const useWidgetElementContext = () => {
  return useContext(WidgetElementContext);
};

export const WidgetElementProvider: React.FC<
  WidgetElementContextProps & { children: React.ReactNode }
> = (props) => {
  return (
    <WidgetElementContext.Provider value={props}>
      {props.children}
    </WidgetElementContext.Provider>
  );
};
